import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createInfiniteQueryHook from '@segment/utils/createInfinityQueryHook';
import { createFsCacheProxy } from '@segment/utils/fsCache';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
var DEFAULT_LIMIT = 3;
var DEFAULT_OFFSET = 0;
export var fetchFeaturedGDBMData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var enabled, filterParams, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            filterParams = new URLSearchParams();
            filterParams.set("fields.featuredEpisode", "true");
            filterParams.set("order", "-fields.episodeNumber");
            _context.next = 6;
            return createFsCacheProxy(["goodDataBetterMarketing/goodDataBetterMarketingDataFeaturedQuery", filterParams.toString()], function () {
              return client.get("/content/entries/podcastEpisode?".concat(filterParams.toString())).then(function (data) {
                return data !== null && data !== void 0 && data.length ? data[0] : null;
              });
            }, {
              enabled: enabled
            });

          case 6:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFeaturedGDBMData(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchGDBMData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var pagination,
        enabled,
        _pagination$offset,
        offset,
        _pagination$limit,
        limit,
        searchParams,
        cachedFetch,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            pagination = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _pagination$offset = pagination.offset, offset = _pagination$offset === void 0 ? DEFAULT_OFFSET : _pagination$offset, _pagination$limit = pagination.limit, limit = _pagination$limit === void 0 ? DEFAULT_LIMIT : _pagination$limit;
            searchParams = new URLSearchParams();
            searchParams.set("limit", limit.toString());
            searchParams.set("offset", offset.toString());
            _context2.next = 8;
            return createFsCacheProxy(["goodDataBetterMarketing/goodDataBetterMarketingDataQuery", searchParams.toString()], function () {
              return client.get("/content/filter/podcastEpisodes?".concat(searchParams.toString())).then(function (data) {
                return data.items.length ? data : null;
              });
            }, {
              enabled: enabled
            });

          case 8:
            cachedFetch = _context2.sent;
            return _context2.abrupt("return", cachedFetch());

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchGDBMData(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var createFetchGDBMDataQuery = function createFetchGDBMDataQuery(client) {
  return [["goodDataBetterMarketing", "goodDataBetterMarketingDataQuery"], /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
      var _ref3$pageParam, pagination, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3$pageParam = _ref3.pageParam, pagination = _ref3$pageParam === void 0 ? {} : _ref3$pageParam;
              _context3.next = 3;
              return fetchGDBMData(client, pagination);

            case 3:
              data = _context3.sent;
              return _context3.abrupt("return", data);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }()];
};
export var useFetchGDBMDataQuery = createInfiniteQueryHook(createFetchGDBMDataQuery, useStaticSiteBackend, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    if (!p) return;
    var nextOffset = p.skip - p.limit;

    if (nextOffset < 0) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  },
  getNextPageParam: function getNextPageParam(p) {
    if (!p) return;
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});